import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import user from '../../js/stores/user.js';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $f7route = _ref.$f7route,
    $f7router = _ref.$f7router;
  var isAccountEnabled = false;
  var resultMessage = 'User has been enabled. You can login now.';
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var data, result;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = {
            "id": $f7route.params.userId,
            "code": $f7route.params.userToken
          };
          _context.next = 1;
          return user.dispatch('enableAccount', data);
        case 1:
          result = _context.sent;
          if (result.status !== undefined && result.status !== 200) {
            $f7.toast.show({
              text: result.data.messages.error
            });
            resultMessage = "".concat(result.data.messages.error);
          } else {
            isAccountEnabled = true;
            $f7.toast.show({
              text: resultMessage,
              closeTimeout: 4000
            });
          }
          $update();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="user-enable">
    <div class="navbar">
      <div class="navbar-inner">
        <div class="left">
          <a href="/" class="link">
            <i class="material-icons">home</i>
            <span class="if-not-md">Home</span>
          </a>
        </div>
        <div class="title">Enable User Account</div>
      </div>
    </div>
    <div class="page-content">
      <p class="block text-align-center">
        <h1>
          ${resultMessage}
        </h1>
        <br/>
      </p>
      <p class="grid grid-cols-2 text-align-center">
        <div>
          <a href="/" class="link">
            <i class="material-icons">home</i> Home
          </a>
        </div>
        <div>
          <a class="link color-green" href="/user-login/">
            <span class="material-icons">login</span> Login
          </a>
        </div>
      </p>
      <br/>
    </div>
  </div>
`
    }
    ;
}
framework7Component.id = '07c013b9ce';
export default framework7Component;